import { useImmerAtom } from 'jotai-immer';
import { tableViewAtom, tableFiltersAtom, tableStatsAtom, providerDataAtom } from '../provider_list_atoms';
import { ProviderDataHook } from '../provider_list_types';
import { useTableData } from '../../../../core/table/hooks/useTableData';

export const useProviderData = (): ProviderDataHook => {
    const [view] = useImmerAtom(tableViewAtom);
    const [filters] = useImmerAtom(tableFiltersAtom);
    const [stats, setStats] = useImmerAtom(tableStatsAtom);
    const [data] = useImmerAtom(providerDataAtom);

    const { items } = useTableData({
        view,
        filters,
        stats,
        data,
        setStats,
    });

    return { items, rawDataSize: data.dataItems.length };
};
